import styled from "styled-components";
import { WhiteContainer, WrapperContainer } from "../../components";

export const IFrameContainer = styled(WrapperContainer)`
  iframe {
    border: unset;
    pointer-events: unset;
  }

  .quicksight-embedding-iframe-placeholder {
    height: 100%;
  }

  width: 100%;
  height: 100%;

  background-color: #f6f6f6;
`;

export const DashboardContainer = styled(WhiteContainer)`
  overflow: hidden;
`;
